/*
 * @Author: liyifan
 * @Date: 2024-06-19 16:45:34
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 16:08:27
 * @description: 首页-用户故事 - 仅移动端执行
 */
export class StoriesSwiper {
    constructor() {
        this.init();
    }
    init() {
        new Swiper(".stories-swiper", {
            spaceBetween: 32,
            slidesPerView: 1.2,
            autoplay: false,
            speed: 600,
            loop: true,
            pagination: {
                el: ".stories-pagination",
            },
            on: {
                slideChangeTransitionEnd: function () {
                    // 防止轮播懒加载白屏
                    const currSlide = Array.from(this.slides).filter((it) =>
                        it.classList.contains("swiper-slide-active")
                    );
                    const currImg = currSlide[0].querySelector(".story-item-img");
                    if (currImg && currImg.classList.contains('lazyloading')) {
                        currImg.classList.remove("lazyloading");
                        currImg.classList.add("lazyloaded");
                    }
                },
            }

        });
    }
}
